/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_N8n_Art_State_3Inputs */

const en_svc_n8n_art_state_3 = /** @type {(inputs: Svc_N8n_Art_State_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completed`)
};

const lv_svc_n8n_art_state_3 = /** @type {(inputs: Svc_N8n_Art_State_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pabeigts`)
};

/**
* | output |
* | --- |
* | "Completed" |
*
* @param {Svc_N8n_Art_State_3Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_n8n_art_state_3 = /** @type {((inputs?: Svc_N8n_Art_State_3Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_N8n_Art_State_3Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_n8n_art_state_3(inputs)
	return en_svc_n8n_art_state_3(inputs)
});